"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = setGlobalOptions;

var _highcharts = _interopRequireDefault(require("highcharts"));

var DEFAULT_THOUSANDS_SEPARATOR = ',';

function setGlobalOptions() {
  _highcharts.default.setOptions({
    lang: {
      thousandsSep: DEFAULT_THOUSANDS_SEPARATOR
    }
  });
}